// import Activity from '../../../containers/DashboardContainers/activityContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import Leaderboard from '../../../containers/DashboardContainers/leaderboardContainer';
import MyStats from '../../../containers/DashboardContainers/myStatsContainer';

class StatsLeaderboardSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleStats: true,
    };
    this.seeStats = this.seeStats.bind(this);
    this.seeLeaderboard = this.seeLeaderboard.bind(this);
  }

  seeStats() {
    this.setState({ visibleStats: true });
  }

  seeLeaderboard() {
    this.setState({ visibleStats: false });
  }

  render() {
    if (this.state.visibleStats) {
      return (
        <div>
          <Row className="mt-3 header-text p-0 m-0 pb-4">
            <Col className="pr-0 mr-0">
              <div
                onClick={this.seeStats}
                className="text-center switch-header-selected w-100 "
              >
                <i className="icon-activity switch-icon" />
                MY STATS
              </div>
            </Col>
            <Col className="pl-0 ml-0">
              <div
                onClick={this.seeLeaderboard}
                className="text-center switch-header"
              >
                <i className="icon-star_border switch-icon" />
                LEADERBOARD
              </div>
            </Col>
          </Row>
          <Row className="m-0">
            <Col xs={12} className="pb-2">
              <MyStats />
            </Col>
            {/* <Col xs={12} className="pt-2">
              <Activity
                gradientId="gradientActyvityProgressBar"
                localStorageItem={this.props.localStorageItemActivity}
              />
            </Col> */}
          </Row>
        </div>
      );
    }
    return (
      <div>
        <Row className="mt-3 header-text p-0 m-0 pb-4">
          <Col className="pr-0 mr-0">
            <div
              onClick={this.seeStats}
              className="text-center w-100 switch-header"
            >
              <i className="icon-activity switch-icon" />
              MY STATS
            </div>
          </Col>
          <Col className="pl-0 ml-0">
            <div
              onClick={this.seeLeaderboard}
              className="text-center switch-header-selected"
            >
              <i className="icon-star_border switch-icon" />
              LEADERBOARD
            </div>
          </Col>
        </Row>
        <Row className="m-0">
          <Col xs={12}>
            <Leaderboard
              localStorageItem={this.props.localStorageItemLeaderboard}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
StatsLeaderboardSwitch.propTypes = {
  localStorageItemLeaderboard: PropTypes.string.isRequired,
  localStorageItemActivity: PropTypes.string.isRequired,
};
export default StatsLeaderboardSwitch;
